module.exports = __webpack_public_path__ + "img/support__img2.89e4c9be.svg";